import React, { useState } from 'react';
import { franceList, franceDelete, franceListUpdate } from '../../../api-services';
import { useMutation, useQueryClient } from 'react-query';
import { Dropdown } from 'react-bootstrap';
import swal from 'sweetalert';
import { openUserDetailsModal } from '../../../redux/features/modalSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrash,
  faEllipsisV,
  faEdit,
} from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from 'react-redux';
import TableManager from '../../../components/TableManager';
import { createTable } from '@tanstack/react-table';
import AddFranceDID from './AddFranceDID';
import { Country as GlobalCountries } from 'country-state-city';
import Country from '../../../components/Country';

const table = createTable();

const DateFilterTypes = [
  { label: 'Today', value: 'Today' },
  { label: 'Yesterday', value: 'Yesterday' },
  { label: 'Last 7 Days', value: 'Last 7 Days' },
  { label: 'Last 30 Days', value: 'Last 30 Days' },
  { label: 'This Month', value: 'This Month' },
  { label: 'Last Month', value: 'Last Month' },
  { label: 'Custom', value: 'Custom' },
];

const statusOptions = [
  { label: 'Active', value: 'A' },
  { label: 'Deactive', value: 'D' },
];
const numberFilterTypes = [
  { label: 'Less Than', value: 'less_than' },
  { label: 'Greater Than', value: 'greater_than' },
  { label: 'Is Equal To', value: 'is_equal' },
  { label: 'Is Not Equal To', value: 'is_not_equal' },
  { label: 'Less or Equal to', value: 'less_or_equal' },
  { label: 'Greater or Equal to', value: 'greater_or_equal' },
];

const initialValues = {
  filter: [
    {
      did_number: '',
      a_filter_type: '',
      placeholder: 'Enter Did Number...',
      type: 'text',
      shouldFilterOptionDisabled: false,
      filterOptions: numberFilterTypes,
      label: 'Did Number',
    },

    {
      did_city: '',
      a_filter_type: '',
      placeholder: 'Enter City...',
      type: 'text',
      shouldFilterOptionDisabled: true,
      label: 'City',
    },
    {
      country: '',
      a_filter_type: '',
      placeholder: 'Select Country...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: GlobalCountries?.getAllCountries(),
      label: 'Country',
    },
    {
      did_status: '',
      a_filter_type: '',
      placeholder: 'Select Status...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: statusOptions,
      label: 'Status',
    },

    {
      date: {
        from: '',
        to: '',
      },
      a_filter_type: '',
      placeholder: 'Custom Date Range...',
      type: 'date',
      shouldFilterOptionDisabled: false,
      filterOptions: DateFilterTypes,
      selectOptions: [],
      label: 'Date',
    },
  ],
};

const FranceDID = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [filters, setFilters] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const [addDID, setAddDID] = useState(false);
  const [editData, setEditData] = useState({});

  const { mutateAsync: mutateAsyncdelete } = useMutation(
    'franceDelete',
    franceDelete,
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message ?? 'Success!',
          icon: 'success',
          type: 'success',
          timer: 2000,
        }).then(() => {
          queryClient.invalidateQueries('franceList');
        });
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );

  const handleDeleteNumber = (val) => {
    swal({
      text: 'Are you sure you want to delete this Number ?',
      buttons: true,
      icon: 'warning',
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          let payload = {
            didID: val?.didID,
          };
          await mutateAsyncdelete(payload);
        } catch (error) {
          console.log(error);
        }
      }
    });
  };

  const handleStatus = (val) => {
    switch (val) {
      case 'A':
        return 'Assigned';
      case 'P':
        return 'Pending';
      case 'U':
        return 'Unassigned';
      case 'E':
        return 'Expired';
      default:
        return '---';
    }
  };

  const handleEditNumber = (val) => {
    setEditData(val);
    setAddDID(true);
  };

  const handleAddDID = () => {
    setAddDID(true);
  };

  const handleOpenUserDetails = (shouldOpen, data) => {
    if (!shouldOpen) {
      return false;
    }

    dispatch(
      openUserDetailsModal({
        userModalOpen: true,
        userModalData: data,
      }),
    );
  };

  const columns = [
    table.createDataColumn('did_number', {
      id: 'did_number',
      header: 'DID Number',
      textAlign: 'left',
    }),
    table.createDataColumn((row) => row?.customer?.msisdn, {
      id: 'msisdn',
      header: 'Assign to',
      isSortable: true,
      shouldPointer: true,
      cell: (props) => (
        <span
          className="hover-name"
          onClick={() =>
            handleOpenUserDetails(
              props.getValue(),
              props?.row?.original?.customer,
            )
          }
        >
          {props.getValue()}
        </span>
      ),
    }),
    table.createDataColumn('assign_at', {
      id: 'assign_at',
      header: 'Assign at',
      isSortable: true,
    }),
    table.createDataColumn('did_status', {
      id: 'did_status',
      header: 'Status',
      cell: (props) => handleStatus(props.getValue()),
    }),
    table.createDataColumn('created_at', {
      id: 'created_at',
      header: 'Country',
      textAlign: 'left',
      cell: () => <Country isoCode={'FR'} />,
    }),
    table.createDisplayColumn({
      id: 'action',
      header: 'Action',
      cell: (props) => (
        <span>
          <Dropdown className="dropdown_dot mx-auto">
            <Dropdown.Toggle
              id="dropdown-basic"
              className="btn-light-blue btn-action "
            >
              <FontAwesomeIcon icon={faEllipsisV} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                href={void 0}
                onClick={() => handleEditNumber(props.row.original)}
              >
                <FontAwesomeIcon icon={faEdit} />
                Edit
              </Dropdown.Item>
              <Dropdown.Item
                href={void 0}
                onClick={() => handleDeleteNumber(props.row.original)}
              >
                <FontAwesomeIcon icon={faTrash} />
                Delete
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </span>
      ),
    }),
  ];

  return (
    <>
      <TableManager
        table={table}
        columns={columns}
        filter={filters}
        fetcherKey="franceList"
        fetcherFn={franceListUpdate}
        title="Stock DID"
        cta={true}
        ctaFunction={handleAddDID}
        ctaLabel="Add DID"
        shouldFilter={true}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        initialValues={initialValues}
        setFilters={setFilters}
        filters={filters}
      />

      {addDID && (
        <AddFranceDID
          setOpenModal={setAddDID}
          openModal={addDID}
          editData={editData}
          setEditData={setEditData}
        />
      )}
    </>
  );
};

export default FranceDID;
